import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ConfirmationModal from './index';
import 'assets/scss/confirmation-modal.css';
import user_check_icon from 'assets/img/confirmation_mail_user_checked.svg';

const EmailConfirmationSent = ({ isVisible, email, toggleModal }) => {
  return (
    <ConfirmationModal isVisible={isVisible} toggleModal={toggleModal}>
      <img className="mb-5" src={user_check_icon} />
      <h2>Email Confirmation</h2>
      <p>
        A confirmation email has been sent to <Link to="/">{email}</Link> please
        check your email for confirmation link.
      </p>
      <button
        onClick={() => toggleModal(email)}
        className="btn btn-warning btn-sm py-3 pl-5 pr-5 text-white text-bold border-0 mb-2"
      >
        OK
      </button>
    </ConfirmationModal>
  );
};

EmailConfirmationSent.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
};

export default EmailConfirmationSent;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/Modal/EmailConfirmationSent.js